export const FAMILLE_SEARCH_SUCCES = "FAMILLE_SEARCH_SUCCES";
export const FAMILLE_SEARCH_ECHEC = "FAMILLE_SEARCH_ECHEC";
export const FAMILLE_SEARCH_REQUETTE_LOC = "FAMILLE_SEARCH_REQUETTE_LOC";
export const FAMILLE_SEARCH_SUCCES_LOC = "FAMILLE_SEARCH_SUCCES_LOC";
export const FAMILLE_SEARCH_ECHEC_LOC = "FAMILLE_SEARCH_ECHEC_LOC";
export const FAMILLE_SEARCH_REQUETTE = "FAMILLE_SEARCH_REQUETTE";
export const FAMILLE_SEARCH_RESET = "FAMILLE_SEARCH_RESET";
export const FAMILLE_LISTE_REQUETTE = "FAMILLE_LISTE_REQUETTE";
export const FAMILLE_LISTE_SUCCES = "FAMILLE_LISTE_SUCCES";
export const FAMILLE_LISTE_ECHEC = "FAMILLE_LISTE_ECHEC";
